import{$}from"@olmokit/dom/$";import{setVendorCSS}from"@olmokit/dom/setVendorCSS";/**
 * Collapsable
 *
 * Simple utility to make an element collapsable. It requires the element
 * not to have vertical margins, as we simply read the "inner" height of the
 * given element.
 */export function Collapsable(selector,$root,options){let{duration=300,expanded,collapsed}=options||{},$el="string"==typeof selector?$(selector,$root):selector;if(!$el)return;let lastHeight=$el.scrollHeight,isExpanded=lastHeight>0;/**
   * Set ARIA attribute on the element to flag the expanded status
   */function setAriaExpanded(expanded){$el.setAttribute("aria-expanded",expanded+"")}/**
   * Expand element
   *
   * @param immediate Run without animation
   */function expand(immediate){immediate?_doExpand():($el.style.height=`${$el.scrollHeight}px`,setTimeout(_doExpand,duration+1))}/**
   * Actually expand
   */function _doExpand(){$el.style.height="auto",lastHeight=$el.scrollHeight,setAriaExpanded(!0),isExpanded=!0,expanded&&expanded($el)}/**
   * Collapse element
   *
   * @param immediate Run without animation
   */function collapse(immediate){immediate?_doCollapse():($el.style.height=`${lastHeight}px`,setTimeout(_doCollapse,3))}/**
   * Actually collapse
   */function _doCollapse(){$el.style.height="0",setAriaExpanded(!1),isExpanded=!1,setTimeout(()=>{collapsed&&collapsed($el)},duration+3)}return $el.style.overflow="hidden",setVendorCSS($el,"transition",`height ${duration}ms ease`),setAriaExpanded(isExpanded),{toggle:/**
   * Toggle element
   */function(){isExpanded?collapse():expand()},expand,collapse}}export default Collapsable;